<template>
    <div class="job-gotten">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" />
                    <span class="go-back pointer" @click="goBack">Go Back</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div class="row">
                            <div class="col-8">
                                <h3 class="font-weight-bolder kova-text text-left">Customise Wordpress Login</h3>
                            </div>
                            <div class="col-4">
                                <h3 class="kova-text font-weight-bolder text-left">$20 - $169</h3>
                            </div>
                        </div>
                        <div>
                            <a-tabs defaultActiveKey="1">
                                <a-tab-pane tab="Details" key="1">
                                    <div class="bg-light border add-rounded p-4 mt-4">
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-9">
                                                <div class="row pl-3">
                                                    <div>
                                                        <h4 class="font-weight-bolder text-left">
                                                            Customise Wordpress Login
                                                        </h4>
                                                    </div>
                                                    <div class="kova-id ml-3 text-white">ID: 23498</div>
                                                </div>
                                                <h4 class="text-left mt-3">Brief</h4>
                                                <p class="text-left">
                                                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                                                    nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
                                                    et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                                                    Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
                                                    sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
                                                    et dolore magna aliquyam erat, sed diam
                                                </p>
                                                <h4 class="text-left mt-3">Skills Required</h4>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span
                                                        class="bg-skills px-3 py-2 mr-3 mb-3 rounded pointer ctrl-size-2"
                                                        v-for="skill in skills"
                                                        :key="skill"
                                                    >
                                                        {{ skill }}</span
                                                    >
                                                </div>
                                                <h4 class="text-left mt-3">Budgets</h4>
                                                <div class="row pl-3">
                                                    <div>
                                                        <h4 class="text-left font-weight-bolder">$1,340 - $3,000 .</h4>
                                                    </div>
                                                    <div class="ml-3 mt-2 incr-font-2">$20.00/hr</div>
                                                </div>
                                                <div class="mt-3">
                                                    <p
                                                        class="ant-color text-left"
                                                        v-if="showmore"
                                                        @click="showOtherDetails"
                                                    >
                                                        View More Details<a-icon
                                                            class="ml-2"
                                                            type="double-right"
                                                            :rotate="90"
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3">
                                                <div class="text-right font-weight-bolder">
                                                    <font-awesome-icon icon="clock" class="mr-2" />You were hired
                                                </div>
                                            </div>
                                        </div>
                                        <div class="" v-if="otherDetails">
                                            <hr />
                                            <div class="row mt-2 text-left">
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">UI/UX Prototype</h6>
                                                    <p class="ctrl-size-2">Project Specification</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">10 - 30 hrs/week</h6>
                                                    <p class="ctrl-size-2">Hours needed</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">3 - 6 Months</h6>
                                                    <p class="ctrl-size-2">Project Timeline</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">1 of 4 Hired</h6>
                                                    <p class="ctrl-size-2">Developers to hire</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        <font-awesome-icon
                                                            style="font-size: 14px;"
                                                            icon="map-marker-alt"
                                                            class="text-dark mr-1"
                                                        ></font-awesome-icon
                                                        >Lagos, Nigeria
                                                    </h6>
                                                    <p class="ctrl-size ml-3">Location</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">Interviewing: 6</h6>
                                                    <p class="ctrl-size-2">Interview</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <div class="">
                                                <h5 class="text-left">Specialization</h5>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span
                                                        class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 mt-2"
                                                        v-for="skill in specialization"
                                                        :key="skill"
                                                    >
                                                        {{ skill }}</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="">
                                                <h5 class="text-left">Attached Files</h5>
                                                <div class="text-left d-flex flex-wrap">
                                                    <button class="btn-kovatek py-2 px-2 add-rounded">
                                                        <a-icon type="upload" /> Download
                                                    </button>
                                                </div>
                                            </div>
                                            <p class="ant-color text-left mt-3" @click="showLessDetails">
                                                Show Less <a-icon class="ml-2" type="double-right" rotate="-90" />
                                            </p>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <div class="">
                                        <h4 class="text-left kova-text font-weight-bolder mt-5">Place Bid</h4>
                                        <div class="text-left">
                                            <a-icon type="exclamation-circle" class="icon-size" />
                                            <span class="ml-3"
                                                >You will be able to edit your bid till you are awarded the
                                                project</span
                                            >
                                        </div>

                                        <h4 class="text-left mt-4">Cover Letter</h4>
                                        <a-textarea
                                            class="px-3 py-3 mb-3"
                                            placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod temporinvidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
                                            :rows="4"
                                        />
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <h5 class="text-left mt-4 ml-3">Bill Amount</h5>
                                                <a-input-group compact>
                                                    <a-input
                                                        size="large"
                                                        class="text-left"
                                                        style="width: 70%"
                                                        placeholder="2000"
                                                    />
                                                    <a-select size="large" class="text-left" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                        <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <h5 class="text-left mt-4 ml-3">Delivery Timeline in Days</h5>
                                                <a-input-group compact>
                                                    <a-input
                                                        size="large"
                                                        class="text-left"
                                                        style="width: 70%"
                                                        placeholder="7"
                                                    />
                                                    <a-select size="large" class="text-left" defaultValue="Days">
                                                        <a-select-option value="Days">Days</a-select-option>
                                                        <a-select-option value="Weeks">Weeks</a-select-option>
                                                        <a-select-option value="Months">Months</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <h5 class="text-left mt-3 ml-3 pl-2">Milestone</h5>
                                            <div :key="mile" v-for="mile in mileStone" class="text-left ml-4">
                                                <a-input-group compact class="mt-3 font-weight-bolder">
                                                    <a-input
                                                        size="large"
                                                        :value="mile.title"
                                                        class="text-left mr-3 font-weight-bold"
                                                        style="width: 50%"
                                                        :placeholder="mile.title"
                                                    />
                                                    <a-input
                                                        size="large"
                                                        :value="mile.amount"
                                                        class="text-left font-weight-bold"
                                                        style="width: 15%"
                                                        :placeholder="mile.amount"
                                                    />
                                                    <a-select size="large" class="text-left" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                        <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                                <div
                                                    class="text-left mt-3 pb-2 pl-sm-3 ml-3 ml-sm-4 pl-md-4 ml-lg-5 pl-lg-5"
                                                >
                                                    <span class="bg-light p-2 rounded"
                                                        >Monday, 20th of January, 2020</span
                                                    >
                                                    <a-icon class="ml-1" type="edit" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-right my-4">
                                        <button class="btn-kovatek">Place Bid</button>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane tab="Proposals" key="2" forceRender>
                                    <!-- <div class="mt-4 mb-5">
                                    <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="work" v-for="work in workHistory">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder kova-text">{{work.title}}</h5>
                                                
                                                <p class="font-italic text-size2">{{work.comment}}</p>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded"  v-for="skills in proSkills" :key="skills">
                                                        {{skills}}</span>
                                                </div>
                                            </div>
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                            <h5 class="font-weight-bolder kova-text">${{work.earned}}</h5>
                                            <h6>Web Developer <span class="text-uppercase intermediate">intermediate</span> </h6>
                                            <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span>

                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                                </div> -->
                                    <div class="mt-4 mb-5">
                                        <div class="p-4 bg-light border shadow-sm add-rounded">
                                            <div :key="work" v-for="work in workHistory">
                                                <div class="row">
                                                    <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                        <img
                                                            src="../assets/kovatek/Mask Group 46.svg"
                                                            alt=""
                                                            class="rounded-circle img-height"
                                                        />
                                                    </div>
                                                    <div class="col-9 col-sm-9 col-md-7 text-left">
                                                        <h5 class="font-weight-bolder kova-text">
                                                            {{ work.title }}
                                                            <img
                                                                class="ml-1 ml-md-2 mb-1"
                                                                style="height:22px;"
                                                                src="../assets/kovatek/correct.svg"
                                                                alt=""
                                                            />
                                                            <span class="ml-3"
                                                                ><img
                                                                    class="mr-1 rating"
                                                                    src="../assets/kovatek/best.svg"
                                                                    alt=""
                                                                /><span
                                                                    class="font-weight-bolder ctrl-size-1 kova-green"
                                                                    >9.5</span
                                                                ><span class="ml-2 ctrl-size-2 kova-light"
                                                                    >56 reviews</span
                                                                ></span
                                                            >
                                                        </h5>
                                                        <p>
                                                            <span class="font-italic">Web Developer</span>
                                                            <span class="ml-3 text-uppercase intermediate"
                                                                >intermediate</span
                                                            >
                                                        </p>

                                                        <!-- <span>
                                                    <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                                    <span class="font-weight-light">{{work.duration}}</span>
                                                </span> -->
                                                        <p class="text-size2">
                                                            {{ work.comment }}...
                                                            <span class="ant-color">see more </span>
                                                        </p>
                                                        <div class="text-left d-flex flex-wrap">
                                                            <span
                                                                class="bg-skills px-3 py-2 mr-3 mb-3 rounded"
                                                                v-for="skill in proSkills"
                                                                :key="skill"
                                                            >
                                                                {{ skill }}</span
                                                            >
                                                            <span
                                                                class="px-3 py-2 mr-3 mb-3 rounded"
                                                                style="background-color: #EFEFEF"
                                                            >
                                                                <b>+ more</b></span
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- <div class="col-md-3">

                                            </div> -->
                                                    <div
                                                        class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text"
                                                    >
                                                        <h6 class="font-weight-bolder kova-light ctrl-size-3">
                                                            Project completed: 11
                                                        </h6>
                                                        <h6 class="font-weight-bolder kova-light ctrl-size-3">
                                                            Team Work: 4
                                                        </h6>

                                                        <h5 class="font-weight-bolder kova-text mt-md-5 pt-md-5">
                                                            ${{ work.earned }}
                                                        </h5>
                                                        <!-- <h6>{{work.hours}} hours </h6> -->
                                                        <!-- <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span> -->
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-0 pt-lg-4 mt-lg-5">
                        <div class="pt-2 mt-1 ml-lg-4 mb-5" style="position: sticky; top:50px">
                            <PostedBy />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import PostedBy from '@/components/PostedBy.vue';

export default {
    name: 'job-gotten',
    components: {
        Navbar,
        Footers,
        PostedBy,
    },
    data() {
        return {
            skills: [
                'Laravel Framework',
                'Nodejs',
                'Golang',
                'jQuery',
                'JavaScript',
                'Database',
                'Modeling',
                'Vue.js',
                'Express.js',
                'Ext JS',
                'Docker',
            ],
            workHistory: [
                {
                    title: 'Adebayo Mary',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                },
                {
                    title: 'Adebayo Mary',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                },
                {
                    title: 'Adebayo Mary',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                },
                {
                    title: 'Adebayo Mary',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                },
                {
                    title: 'Adebayo Mary',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                },
                {
                    title: 'Adebayo Mary',
                    star: 5,
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                },
            ],
            proSkills: ['Database', 'Modeling', 'Vue.js'],
            mileStone: [
                { title: 'Login Setub', amount: 210 },
                { title: 'API Integration', amount: 89 },
                { title: 'Front - End', amount: 400 },
                { title: 'Back - End', amount: 600 },
                { title: 'Design sign up and user authentication package', amount: 50 },
            ],
            otherDetails: false,
            showmore: true,
        };
    },
    methods: {
        showOtherDetails() {
            this.otherDetails = !this.otherDetails;
            this.showmore = false;
        },
        showLessDetails() {
            this.otherDetails = !this.otherDetails;
            this.showmore = true;
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped>
.kova-text {
    color: #20409a;
}
.add-rounded {
    border-radius: 10px;
}
.bg-skills {
    background-color: #dde;
}
.incr-font-1 {
    font-size: 20px;
    font-style: italic;
}
.kova-id {
    width: 100px;
    height: 20px;
    background-color: #4bb38e;
    border-radius: 5px;
}
.icon-size {
    font-size: 25px;
}
.bg-kovatek {
    background-color: #20409a;
}
.img-height {
    width: 90px;
    height: 90px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 16px;
}
.intermediate {
    color: rgb(148, 194, 20);
    font-size: 12px;
}
.ctrl-size-1 {
    font-size: 20px;
}
.ctrl-size-2 {
    font-size: 11px;
}
.ctrl-size-3 {
    font-size: 14px;
}
.ctrl-size-4 {
    font-size: 13px;
}
.bg-skills {
    background-color: #4bb38e;
    color: #fff;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .employer-name {
        font-size: 18px;
    }
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>
